import React from "react";
import AccountLinkList from "../../components/user/accountLink/accountLinkFilterList";
import Layout from "../../components/layouts/verticalLayout";

const AccountLinkPage = () => {
  return (
    <Layout
      body={
        <>
          <AccountLinkList />
        </>
      }
    />
  );
};

AccountLinkPage.propTypes = {};

export default AccountLinkPage;
